/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/core/customTaskHandlers/contractBasedInvoiceHandlers/authorizeDeviations"/>
import { addHandler } from "Core/Medius.Core.Web/Scripts/Medius/core/customTaskHandlers/customTaskHandlersProvider";
import * as rest from "Core/Medius.Core.Web/Scripts/Medius/core/communication/json/rest";
import { isContractBasedInvoiceRemediumFlowEnabled } from "Core/Medius.Core.Web/Scripts/Medius/core/featureToggle";

export function register() {
    addHandler({
        canHandle: function (vm: any, _task: any) {
            if(isContractBasedInvoiceRemediumFlowEnabled())
            {
                const isRemediumWorkflow = _task.WorkflowContext && _task.WorkflowContext() === null;
                const isCodeResultConfirmDeviations = vm.Code && vm.Code() === "AuthorizeDeviations";
                const isContractBasedInvoice = _task.Document().$type() === "Medius.ContractbasedInvoice.Entities.ContractbasedInvoice, Medius.ContractbasedInvoice.Common";
                return isRemediumWorkflow && isContractBasedInvoice && isCodeResultConfirmDeviations;
            }

            return false;
        },
        handle: function (task: any, _: any) {
            return function () {
                const request = {
                    DocumentId: task.Document().Id(),
                    UserTaskId: task.Id(),
                    DeviationResults: 
                        task.Document().DeviationResults().map((d: any) => ({ 
                            Id: d.Id(), 
                            IsApproved: d.TaskItem().IsApproved(),
                            IsRejected: d.TaskItem().IsRejected(),
                            Authorizer: d.TaskItem()?.Authorizer()?.Id(),
                            Comment: d.Comment(),
                        }))
                };
                return rest.post("remedium-api", "contractBasedInvoice/workflow/authorizeDeviations", request);
            };
        }
    });
}
